import { InjectionToken } from '@angular/core';

export interface DwollaConfig {
  mode: 'sandbox' | 'prod';
}

export const DWOLLA_CONFIG = new InjectionToken<DwollaConfig>('DWOLLA_CONFIG');
